/**
 * Number-formatting locale per currency, for `Intl.NumberFormat`.
 *
 * NOT a UI language map, despite the name it inherited. `formatNumericValue`
 * picks the locale from the CURRENCY of the amount so that a price is punctuated
 * the way its own market writes it, independently of the language on screen.
 * `es-UY` is here for exactly that reason: Uruguay is not a language this app
 * ships, and it is not meant to be.
 *
 * Tags are canonical BCP-47 and go straight into `Intl` — the code that
 * consumed this used to rebuild them with `value.split('_')[1].toUpperCase()`,
 * which threw `Cannot read properties of undefined` for any currency missing
 * from the map.
 *
 * KNOWN ODDITY, left as it was: EUR resolves to Spanish. A Portuguese buyer
 * paying in euros gets Spanish punctuation — which happens to be identical to
 * the Portuguese one (1.234,56 €), so nothing is visibly wrong today. Changing
 * it means changing how prices render in a live checkout, which is not this
 * task's to decide.
 */
export const Locale = {
  BRL : 'pt-BR',
  EUR : 'es-ES',
  URY : 'es-ES',
  UYU : 'es-UY',
};

type LocaleKeysTypes = typeof Locale[keyof typeof Locale];

export type { LocaleKeysTypes };
